import { ArrowDownIcon, SearchIcon, EyeIcon, PencilIcon } from "@heroicons/react/outline";
import {
  Typography,
  Popover,
  PopoverHandler,
  PopoverContent,
} from "@material-tailwind/react";
import { useGetIdentity, useTranslation } from "@refinedev/core";
import _, { get } from "lodash";
import { Breadcrumbs } from "components/breadcrumbs";
import React, { useEffect, useState } from "react";
import useWindowWidth from "utills/InitWidthDevice";
import ApiService from "utills/ApiService";
import toast from "react-hot-toast";
import { IUserData } from "interfaces";
import { FullScreenLoading } from "components/fullScreenLoading";
import Pagination from "../components/paginaton";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useSetQueryParams from "../../hooks/useGetQueryParams";
import { forceLogoutUser } from "../../api";
import { isHaveActionPermission } from "utills/helpers";
import { Label } from "components/label";
import Input from "components/input";
import Select from "components/select";
import Button from "components/button";
import Datepicker from "react-tailwindcss-datepicker";
import moment from "moment";
import { twMerge } from "tailwind-merge";
import { PARTICIPANT_IMPORT_SOURCES } from "utills/constants";
import { Tag } from "components/tag";

const WPSAttendeesSportsList = () => {
  const windowWidth = useWindowWidth();
  const { translate, getLocale } = useTranslation();
  // const { data: user } = useGetIdentity<IUserData>();
  const language = getLocale();
  const [searchParams] = useSearchParams();
  const setQueryParams = useSetQueryParams();
  const navigate = useNavigate()

  const [isMobile, setIsMobile] = useState(false);
  const [filterGroup, setFilterGroup] = useState({
    query: "",
    event_id: "",
    category_id: "",
    source: "",
    gte: "",
    lte: "",
  });
  const [page, setPage] = useState(1);
  const [paging, setPaging] = useState(null as any);
  const [loading, setLoading] = useState(false);
  const [isInitDone, setIsInitDone] = useState(false);
  const [query, setQuery] = useState("");
  const [event, setEvent] = useState(null as any);
  const [eventList, setEventList] = useState([] as any);
  const [category, setCategory] = useState(null as any);
  const [categoryList, setCategoryList] = useState([] as any);
  const [attendees, setAttendees] = useState([] as any);
  const [openFilter, setOpenFilter] = useState(false);
  const [token, setToken] = useState<string>("");
  const [isFetchData, setIsFetchData] = useState<boolean>(false);
  const [permissions, setPermissions] = useState(null as any);
  const [source, setSource] = useState("");
  const [createdDate, setCreatedDate] = useState({
    startDate: "",
    endDate: "",
  });

  const breadcrumbItems = [
    {
      label: translate("attendees"),
      href: "/attendees/sports",
    },
    {
      label: translate("sport-attendees"),
      href: "/attendees/sports",
    },
  ];

  const TABLE_HEAD = [
    translate("no"),
    translate("full-name"),
    "Email",
    translate("event-name"),
    translate("category"),
    translate("phone"),
    translate("id-card"),
    translate("order-code"),
    translate("source"),
    translate("action"),
  ];

  const fetchEvents = async (token: string, eventId?: string) => {
    // setLoading(true);

    try {
      const result = await ApiService.get(`events?type=sports`, token);

      if (result) {
        const arr = [
          {
            value: "",
            label: translate("all"),
          },
        ] as any;

        result.forEach((item: any) => {
          if (item.id !== "all") {
            const obj = {
              value: item.id,
              label: get(item, `name_${language}`, ""),
            };

            arr.push(obj);
          }
        });

        const initEvent = arr?.find((a: { value: string; label: string }) => {
          return a.value === eventId;
        });

        console.log("Init event:", initEvent);

        setEventList(arr);
        setEvent(initEvent ?? arr[0]);
      }
    } catch (error: any) {
      // toast.error(error.message);
    } finally {
      // setLoading(false);
    }
  };

  const resetAll = () => {
    setQuery("");
    setEvent(null);
    setEventList([]);
    setCategory(null);
    setCategoryList([]);
    setAttendees([]);
  };

  const resetCategory = () => {
    console.log("Reset category");

    setCategoryList([]);
    setCategory(null);
    // setQueryParams({ category_id: "" });
  };

  const fetchCategories = async (
    token: string,
    eventId: string,
    categoryId?: string
  ) => {
    // setLoading(true);

    try {
      const result = await ApiService.get(
        `events/${eventId}/categories`,
        token
      );

      if (result && result.length > 0) {
        const arr = [
          {
            value: "",
            label: translate("all"),
          },
        ] as any;

        result.forEach((item: any) => {
          const obj = {
            value: item.category_en,
            label: get(item, `category_${language}`, ""),
          };

          arr.push(obj);
        });

        const initCategory = arr?.find(
          (a: { value: string; label: string }) => {
            return a.value === categoryId;
          }
        );

        console.log("Init category:", categoryId, initCategory);

        setCategoryList(arr);
        setCategory(initCategory ?? arr[0]);
      }
    } catch (error: any) {
      // toast.error(error.message);
    } finally {
      // setLoading(false);
    }
  };

  const fetchAttendees = async (
    token: string,
    queryStr: string,
    eventId: string,
    categoryId: string,
    sourceStr: string = "",
    gteStr: string = "",
    lteStr: string = ""
  ) => {
    setLoading(true);

    try {
      const query = queryStr ?? "";
      const event = eventId ?? "";
      const catetory = categoryId ?? "";
      const sourceVal = sourceStr ?? "";
      const gte = gteStr ?? "";
      const lte = lteStr ?? "";

      let cate = catetory ? catetory : "";

      if (cate && cate !== "") {
        if (cate.includes("&")) {
          cate = cate.replace("&", "%26");
        } else if (cate.includes("+")) {
          cate = cate.replace("+", "%2B");
        }
      }

      let url = `participants/page/${page}?limit=10&q=${query}&event_id=${event}&category=${cate}`;
      if (sourceVal) url += `&source=${sourceVal}`;
      if (gte) url += `&gte=${gte}`;
      if (lte) url += `&lte=${lte}`;

      const result = await ApiService.get(url, token);

      // console.log("RESULT:", result);

      if (result) {
        setPaging(result?.paging);
        setAttendees(result?.participants);
      }
    } catch (error: any) {
      // toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleExportData = async () => {
    setLoading(true);

    try {
      const query = filterGroup?.query;
      const eventId = filterGroup?.event_id;
      const categoryId = filterGroup?.category_id;
      const sourceVal = filterGroup?.source;
      const gte = filterGroup?.gte;
      const lte = filterGroup?.lte;

      console.log("Export data query:", { query, eventId, categoryId, sourceVal, gte, lte });

      let url = `exports/participants?q=${query}&event_id=${eventId}&category=${categoryId}`;
      if (sourceVal) url += `&source=${sourceVal}`;
      if (gte) url += `&gte=${gte}`;
      if (lte) url += `&lte=${lte}`;

      const result = await ApiService.get(url, token);

      if (result) {
        toast.success(translate("export-success"));
      }
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInit = (token: string) => {
    resetAll();

    const query = searchParams.get("query") ?? "";
    const eventId = searchParams.get("event_id") ?? "";
    const categoryId = searchParams.get("category_id") ?? "";
    const sourceParam = searchParams.get("source") ?? "";
    const gteParam = searchParams.get("gte") ?? "";
    const lteParam = searchParams.get("lte") ?? "";

    // console.log("QUERY:", { query, eventId, categoryId, sourceParam, gteParam, lteParam });

    // Init filter group
    setFilterGroup({
      query: query,
      event_id: eventId,
      category_id: categoryId,
      source: sourceParam,
      gte: gteParam,
      lte: lteParam,
    });

    if (query) setQuery(query);
    if (sourceParam) setSource(sourceParam);
    if (gteParam || lteParam) {
      setCreatedDate({
        startDate: gteParam || "",
        endDate: lteParam || "",
      });
    }
    
    fetchEvents(token, eventId);
    fetchAttendees(token, query, eventId, categoryId, sourceParam, gteParam, lteParam);

    // Fetch categories if event is selected
    if (eventId && eventId !== "") fetchCategories(token, eventId, categoryId);

    setIsInitDone(true);
    setIsFetchData(false);
  };

  const handleUpdateFilter = (value: string, key: string) => {
    const dataFilter = { ...filterGroup } as any;

    dataFilter[key] = value;
    setFilterGroup({ ...dataFilter });

    if (key === "event_id") {
      setCategoryList([]);
      setCategory(null);
      setFilterGroup({ ...dataFilter, category_id: "" });
    } else {
      setFilterGroup({ ...dataFilter });
    }
  };

  const handleChangeEvent = (event: { value: string; label: string }) => {
    console.log("Change event:", event);
    setEvent(event);
    resetCategory();

    // Get categories
    if (token && event?.value !== "") fetchCategories(token, event?.value);
  };

  const handleApplyFillter = (event: any) => {
    if ((event.key === "Enter" || event.key === "Search") && token) {
      console.log("Apply filter:", filterGroup);

      const queryFilter = filterGroup?.query;
      const eventFilter = filterGroup?.event_id;
      const categoryFilter = filterGroup?.category_id;
      const sourceFilter = filterGroup?.source;
      const gteFilter = filterGroup?.gte;
      const lteFilter = filterGroup?.lte;

      setPage(1);

      fetchAttendees(token, queryFilter, eventFilter, categoryFilter, sourceFilter, gteFilter, lteFilter);

      setQueryParams({
        query: queryFilter,
        event_id: eventFilter,
        category_id: categoryFilter,
        source: sourceFilter,
        gte: gteFilter,
        lte: lteFilter,
      });
    }
  };

  const handleAttendeesPagination = (page: number) => {
    console.log("View page:", page, filterGroup);
    setPage(page);
  };

  const handleRedirectDetail = (id: string) => {
    navigate(`/attendees/sports/${id}/detail`);
  }

  const handleRedirectEdit = (id: string) => {
    navigate(`/attendees/sports/${id}/edit`);
  }

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setToken(userData?.token);
      setIsFetchData(true);
    }
  }, []);

  // Init value
  useEffect(() => {
    if (!isInitDone && isFetchData) handleInit(token);
  }, [language, isFetchData]);

  useEffect(() => {
    if (token && isInitDone) {
      console.log("Fetch attendees data");

      fetchAttendees(
        token,
        filterGroup?.query,
        filterGroup?.event_id,
        filterGroup?.category_id,
        filterGroup?.source,
        filterGroup?.gte,
        filterGroup?.lte
      );
    }
  }, [page]);

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);

      if (userData?.type === "wps") {
        const roles = [] as any;
        setToken(userData?.token);

        userData.permissions.forEach((item: any) => {
          const obj = {
            id: item.resource !== "" ? item.resource : item.app,
            permissions: item.action,
            parrent: item.app,
          };

          roles.push(obj);

          setPermissions(roles);
        });
      }
    }
  }, [windowWidth]);

  const canExportParticipants = isHaveActionPermission(
    "sports",
    "attendees",
    "export",
    permissions
  );

  return (
    <div className="w-full">
      {loading && <FullScreenLoading />}

      <Breadcrumbs
        type="wps"
        breadcrumbItems={breadcrumbItems}
        disableBorder={true}
        additionalLabel={(
          <div className="flex-1 flex gap-[12px] justify-end items-center">
            {isMobile ? (
              <div className="flex items-center gap-5">
                <Popover
                  placement="bottom-start"
                  open={openFilter}
                  handler={setOpenFilter}
                >
                  <PopoverHandler>
                    <SearchIcon className="w-[24px] h-[24px]" />
                  </PopoverHandler>
                  <PopoverContent
                    onPointerEnterCapture="none"
                    onPointerLeaveCapture="none"
                    onResize={() => {}}
                    onResizeCapture={() => {}}
                    className="w-96 popup-search-coupon"
                    placeholder="PopoverContent"
                  >
                    <div className="flex flex-col gap-3">
                      {/* Name */}
                      {/* <div className="w-full">
                        <div className="text-14 font-500 mb-[8px]">
                          {translate("search")}
                        </div>

                        <input
                          className="w-full h-[38px] text-14 border border-[#c5ccd2] rounded-[4px]"
                          placeholder={translate(
                            "placeholder-search-sport-attendees"
                          )}
                          value={query}
                          onChange={(e: any) => {
                            setQuery(e.target.value);
                            handleUpdateFilter(e.target.value, "query");
                          }}
                        />
                      </div> */}

                      <div className="w-full">
                        <Label id="search" name={translate("search")} />
                        <div className="mt-2">
                          <Input
                            className="px-2 py-2"
                            label="Search"
                            id="search"
                            type="text"
                            placeholder={translate("placeholder-search-sport-attendees")}
                            value={query}
                            onChange={(e: any) => {
                              setQuery(e.target.value);
                              handleUpdateFilter(e.target.value, "query");
                            }}
                          />
                        </div>
                      </div>

                      {/* Events */}
                      {/* {eventList.length > 0 && event && (
                        <div className="w-full">
                          <div className="text-14 font-500 mb-[8px]">
                            {translate("event-name")}
                          </div>

                          <Select
                            styles={{
                              input: (base) => ({
                                ...base,
                                "input:focus": {
                                  boxShadow: "none",
                                },
                              }),
                            }}
                            value={event}
                            defaultValue={event}
                            name="events"
                            options={eventList}
                            className="text-14"
                            classNamePrefix="select"
                            placeholder={eventList[0].label}
                            onChange={(e: any) => {
                              handleChangeEvent(e);
                              handleUpdateFilter(e.value, "event_id");
                            }}
                          />
                        </div>
                      )} */}

                      {eventList?.length > 0 && event && (
                        <div className="w-full">
                          <Label id="event_id" name={translate("event-name")} />
                          <div className="mt-2">
                            <Select
                              options={eventList}
                              id="event_id"
                              placeholder={eventList[0]?.label}
                              className="py-0.5"
                              value={event}
                              onChange={(selected: { label: string; value: string }) => {
                                handleChangeEvent(selected);
                                handleUpdateFilter(selected?.value, "event_id");
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {/* Categories */}
                      {/* {categorytList.length > 0 && category && (
                        <div className="w-full">
                          <div className="text-14 font-500 mb-[8px]">
                            {translate("category")}
                          </div>

                          <Select
                            styles={{
                              input: (base) => ({
                                ...base,
                                "input:focus": {
                                  boxShadow: "none",
                                },
                              }),
                            }}
                            value={category}
                            defaultValue={category}
                            name="categories"
                            options={categorytList}
                            className="text-14"
                            classNamePrefix="select"
                            placeholder={categorytList[0].label}
                            onChange={(e: any) => {
                              setCategory(e);
                              handleUpdateFilter(e.value, "category_id");
                            }}
                          />
                        </div>
                      )} */}
                      {categoryList?.length > 0 && category && (
                        <div className="w-full">
                          <Label id="category_id" name={translate("category")} />
                          <div className="mt-2">
                            <Select
                              options={categoryList}
                              id="category_id"
                              placeholder={categoryList[0]?.label || translate("select-category") || "Select Category"}
                              className="py-0.5"
                              value={category}
                              onChange={(selected: { label: string; value: string }) => {
                                setCategory(selected);
                                handleUpdateFilter(selected?.value, "category_id");
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {/* Source Filter */}
                      <div className="w-full">
                        <Label id="source" name={translate("source") || "Source"} />
                        <div className="mt-2">
                          <Select
                            options={PARTICIPANT_IMPORT_SOURCES}
                            isClearable={true}
                            id="source"
                            placeholder={translate("select-source") || "Select Source"}
                            className="py-0.5"
                            value={PARTICIPANT_IMPORT_SOURCES.find((d) => d.value === source)}
                            onChange={(selected: { label: string; value: string }) => {
                              setSource(selected?.value || "");
                              handleUpdateFilter(selected?.value || "", "source");
                            }}
                          />
                        </div>
                      </div>

                      {/* Created Date Filter */}
                      <div className="w-full">
                        <Label id="created_date" name={translate("created-date") || "Created Date"} />
                        <div className="mt-2">
                          <Datepicker
                            key={"created_date_mobile"}
                            value={createdDate}
                            onChange={(value) => {
                              const newCreatedDate = {
                                startDate: value?.startDate
                                  ? moment(value?.startDate).format("YYYY-MM-DD")
                                  : "",
                                endDate: value?.endDate
                                  ? moment(value?.endDate).format("YYYY-MM-DD")
                                  : "",
                              };
                              setCreatedDate(newCreatedDate);
                              setFilterGroup({
                                ...filterGroup,
                                gte: newCreatedDate.startDate,
                                lte: newCreatedDate.endDate,
                              });
                            }}
                            displayFormat="DD/MM/YYYY"
                            placeholder={`${translate("start-date")} - ${translate("end-date")}`}
                            inputClassName="date-picker"
                            popoverDirection="down"
                            containerClassName={(className) => twMerge(className, "date-picker-container")}
                          />
                        </div>
                      </div>

                      {/* <Button
                        placeholder="Button search coupon"
                        className="w-[136px] h-[38px] border border-[#a6a1fd] text-14 text-brand-500 bg-white flex items-center justify-center mt-[30px]"
                        onPointerEnterCapture="none"
                        onPointerLeaveCapture="none"
                        onResize={() => {}}
                        onResizeCapture={() => {}}
                        onClick={() => {
                          handleApplyFillter({ key: "Search" });
                        }}
                      >
                        <SearchIcon className="w-4 h-4 icon-search" />
                        <span>{translate("search")}</span>
                      </Button> */}

                      <Button
                        className="mt-2 ml-auto w-[136px] bg-white rounded-md px-3 text-brand-500 py-2
                                        border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85"
                        onClick={() => {
                          handleApplyFillter({ key: "Search" });
                        }}
                      >
                        <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> {translate("search")}
                      </Button>
                    </div>
                  </PopoverContent>
                </Popover>

                {/* <div
                  className="size-[48px] flex items-center justify-center bg-brand-500 rounded-[8px]"
                  onClick={() => {
                    handleExportData();
                  }}
                >
                  <ArrowDownIcon
                    className="size-[16px] text-white"
                    strokeWidth={3}
                  />
                </div> */}

                {canExportParticipants && (
                  <Button
                    className="w-11 h-11 sm:w-auto"
                    onClick={() => {
                      handleExportData();
                    }}
                  >
                    <ArrowDownIcon className="w-4 h-4 text-white" />{" "}
                  </Button>
                )}
              </div>
            ) : canExportParticipants ? (
              <Button
                className="w-11 h-11 sm:w-auto"
                onClick={() => {
                  handleExportData();
                }}
              >
                <ArrowDownIcon className="w-4 h-4 text-white" />{" "}
                <span className="hidden sm:block sm:ml-2">{translate("btn-export-participants")}</span>
              </Button>
            ) : null}
          </div>
        )}
      />

      <div className="w-full">
        <div
          className="w-full p-[16px] grid grid-cols-1 gap-[16px]"
          onKeyDown={handleApplyFillter}
        >
          {/* Filterbar */}
          {!isMobile && (
            <div className="box-container w-full flex flex-col gap-y-4">
              {/* Row 1: Search, Event, Category */}
              <div className="flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
                <div className="flex-1">
                  <Label id="search" name={translate("search")} />
                  <div className="mt-2">
                    <Input
                      className="px-2 py-2"
                      label="Search"
                      id="search"
                      type="text"
                      placeholder={translate("placeholder-search-sport-attendees")}
                      value={query}
                      onChange={(e: any) => {
                        setQuery(e.target.value);
                        handleUpdateFilter(e.target.value, "query");
                      }}
                    />
                  </div>
                </div>

                {eventList?.length > 0 && event && (
                  <div className="flex-1">
                    <Label id="event_id" name={translate("event-name")} />
                    <div className="mt-2">
                      <Select
                        options={eventList}
                        id="event_id"
                        placeholder={eventList[0]?.label}
                        className="py-0.5"
                        value={event}
                        onChange={(selected: { label: string; value: string }) => {
                          handleChangeEvent(selected);
                          handleUpdateFilter(selected?.value, "event_id");
                        }}
                      />
                    </div>
                  </div>
                )}
                {categoryList?.length > 0 && category && (
                  <div className="flex-1">
                    <Label id="category_id" name={translate("category")} />
                    <div className="mt-2">
                      <Select
                        options={categoryList}
                        id="category_id"
                        placeholder={categoryList[0]?.label || translate("select-category") || "Select Category"}
                        className="py-0.5"
                        value={category}
                        onChange={(selected: { label: string; value: string }) => {
                          setCategory(selected);
                          handleUpdateFilter(selected?.value, "category_id");
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Row 2: Source, Created Date, Search Button */}
              <div className="flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
                <div className="flex-1">
                  <Label id="source" name={translate("source") || "Source"} />
                  <div className="mt-2">
                    <Select
                      options={PARTICIPANT_IMPORT_SOURCES}
                      isClearable={true}
                      id="source"
                      placeholder={translate("select-source") || "Select Source"}
                      className="py-0.5"
                      value={PARTICIPANT_IMPORT_SOURCES.find((d) => d.value === source)}
                      onChange={(selected: { label: string; value: string }) => {
                        setSource(selected?.value || "");
                        handleUpdateFilter(selected?.value || "", "source");
                      }}
                    />
                  </div>
                </div>

                <div className="flex-1">
                  <Label id="created_date" name={translate("created-date") || "Created Date"} />
                  <div className="mt-2">
                    <Datepicker
                      key={"created_date"}
                      value={createdDate}
                      onChange={(value) => {
                        const newCreatedDate = {
                          startDate: value?.startDate
                            ? moment(value?.startDate).format("YYYY-MM-DD")
                            : "",
                          endDate: value?.endDate
                            ? moment(value?.endDate).format("YYYY-MM-DD")
                            : "",
                        };
                        setCreatedDate(newCreatedDate);
                        setFilterGroup({
                          ...filterGroup,
                          gte: newCreatedDate.startDate,
                          lte: newCreatedDate.endDate,
                        });
                      }}
                      displayFormat="DD/MM/YYYY"
                      placeholder={`${translate("start-date")} - ${translate("end-date")}`}
                      inputClassName="date-picker"
                      popoverDirection="down"
                      containerClassName={(className) => twMerge(className, "date-picker-container")}
                    />
                  </div>
                </div>

                <div className="shrink-0">
                  <Label
                    id="search-btn"
                    name="&nbsp;"
                  />
                  <div className="mt-2 w-full">
                    <Button
                      type="submit"
                      className="w-full bg-white rounded-md px-3 text-brand-500 py-2 border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85"
                      onClick={() => handleApplyFillter({ key: "Search" })}
                    >
                      <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> {translate("search")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isMobile ? (
            <div className="w-full box-container">
              <div className="flex flex-col gap-3">
                {attendees.length > 0 &&
                  attendees.map((item: any, index: number) => {
                    return (
                      <div
                        className="bg-white rounded-[8px] shadow-md p-[16px] flex flex-col gap-3"
                        key={`attendees-item-${index}`}
                      >
                        <div className="attendees-item__row flex items-center justify-between">
                          <span className="w-[200px] max-w-[200px] truncate text-[14px] font-[500]">
                            {translate("action")}
                          </span>

                          <div className="flex items-center w-[100%] justify-end gap-3">
                            <Button
                              className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300"
                              onClick={() => {
                                handleRedirectDetail(get(item, "participant_id", ""));
                              }}
                            >
                              <EyeIcon className="w-4 h-4 text-black" />
                            </Button>

                            {isHaveActionPermission(
                              "sports",
                              "attendees",
                              "edit",
                              permissions
                            ) && (
                              <Button
                                className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300"
                                onClick={() => {
                                  handleRedirectEdit(get(item, "participant_id", ""));
                                }}
                              >
                                <PencilIcon className="w-4 h-4 text-black" />
                              </Button>
                            )}
                          </div>
                        </div>

                        <div className="attendees-item__row flex">
                          <div className="attendees-item__row__label w-[150px] min-w-[150px] max-w-[150px] text-[14px] font-[500]">
                            {translate("no")}
                          </div>
                          <div className="attendees-item__row__value">
                            {index < 9 && (
                              <span className="text-[14px] font-[400]">
                                {paging.current_page - 1}
                                {index + 1}
                              </span>
                            )}

                            {index === 9 && (
                              <span className="text-[14px] font-[400]">
                                {paging.current_page}0
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="attendees-item__row flex">
                          <div className="attendees-item__row__label w-[150px] min-w-[150px] max-w-[150px] text-[14px] font-[500]">
                            {translate("full-name")}
                          </div>
                          <div className="attendees-item__row__value text-[14px] font-[400]">
                            <Link
                              to={`/attendees/sports/${item.participant_id}/detail`}
                              className="w-fit font-medium text-brand-500 hover:underline"
                            >
                              {get(item, "full_name", "")}
                            </Link>
                          </div>
                        </div>

                        <div className="attendees-item__row flex">
                          <div className="attendees-item__row__label w-[150px] min-w-[150px] max-w-[150px] text-[14px] font-[500]">
                            {translate("email")}
                          </div>
                          <div className="attendees-item__row__value text-[14px] font-[400]">
                            {item.email}
                          </div>
                        </div>

                        <div className="attendees-item__row flex">
                          <div className="attendees-item__row__label w-[150px] min-w-[150px] max-w-[150px] text-[14px] font-[500]">
                            {translate("event-name")}
                          </div>
                          <div className="attendees-item__row__value text-[14px] font-[400]">
                            {get(item, `event_name_${language}`, "")}
                          </div>
                        </div>

                        <div className="attendees-item__row flex">
                          <div className="attendees-item__row__label w-[150px] min-w-[150px] max-w-[150px] text-[14px] font-[500]">
                            {translate("category")}
                          </div>
                          <div className="attendees-item__row__value text-[14px] font-[400]">
                            {item.category_name_vi}
                          </div>
                        </div>

                        <div className="attendees-item__row flex">
                          <div className="attendees-item__row__label w-[150px] min-w-[150px] max-w-[150px] text-[14px] font-[500]">
                            {translate("phone")}
                          </div>
                          <div className="attendees-item__row__value text-[14px] font-[400]">
                            {item.phone}
                          </div>
                        </div>

                        <div className="attendees-item__row flex">
                          <div className="attendees-item__row__label w-[150px] min-w-[150px] max-w-[150px] text-[14px] font-[500]">
                            {translate("id-card")}
                          </div>
                          <div className="attendees-item__row__value text-[14px] font-[400]">
                            {item.id_card}
                          </div>
                        </div>

                        <div className="attendees-item__row flex">
                          <div className="attendees-item__row__label w-[150px] min-w-[150px] max-w-[150px] text-[14px] font-[500]">
                            {translate("order-code")}
                          </div>
                          <div className="attendees-item__row__value text-[14px] font-[400]">
                            <Link
                              to={`/orders/${item.order_code}`}
                              className="w-fit font-medium text-brand-500 hover:underline"
                            >
                              {get(item, "order_code", "")}
                            </Link>
                          </div>
                        </div>
                        <div className="attendees-item__row flex">
                          <div className="attendees-item__row__label w-[150px] min-w-[150px] max-w-[150px] text-[14px] font-[500]">
                            {translate("source")}
                          </div>
                          <div className="attendees-item__row__value text-[14px] font-[400]">
                            <Tag text={item.source} type="blue" customClassName="capitalize" />
                          </div>
                        </div>

                        {/* <div className="attendees-item__row">
                          <div className="attendees-item__row__label">{t('status')}</div>
                          <div className="attendees-item__row__value">
                            {
                              item.status === 1 ?
                                <span>{t('active')}</span>
                                :
                                <span>{t('in-active')}</span>
                            }
                          </div>
                        </div> */}
                      </div>
                    );
                  })}
              </div>

              {paging && paging.total_page > 1 && (
                <Pagination
                  showTotal={false}
                  paging={paging}
                  handlePageChange={handleAttendeesPagination}
                  centerPagination
                />
              )}
            </div>
          ) : (
            <div className="box-container w-full">
              <div className="w-full overflow-x-auto overflow-y-hidden rounded-md">
                <table className="w-full min-w-max table-auto text-left">
                  <thead className="bg-magnolia-500">
                    <tr>
                      {TABLE_HEAD.map((head) => (
                        <th key={head} className="p-4">
                          <Typography
                            variant="small"
                            className="!font-600 text-14"
                            placeholder="Typography"
                            onPointerEnterCapture="none"
                            onPointerLeaveCapture="none"
                            onResize={() => {}}
                            onResizeCapture={() => {}}
                          >
                            {head}

                            {/* {
                            head === t('status') &&
                            <Tooltip content={<span dangerouslySetInnerHTML={{ __html: t('tooltip-status') }} />} placement="left">
                              <img src="/images/icons/tooltip.svg" className="icon-tooltip" alt="icon-tooltip" />
                            </Tooltip>
                          } */}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {attendees.length > 0 &&
                      attendees.map((item: any, index: number) => {
                        const isLast = index === attendees.length - 1;
                        const classes = isLast
                          ? "p-4"
                          : "p-4 border-b border-blue-gray-50";

                        return (
                          <tr
                            key={`event_${item.code}_${index}`}
                            className="table-row"
                          >
                            <td className={classes}>
                              <Typography
                                variant="small"
                                className="font-normal"
                                placeholder="Typography"
                                onPointerEnterCapture="none"
                                onPointerLeaveCapture="none"
                                onResize={() => {}}
                                onResizeCapture={() => {}}
                              >
                                {index < 9 && (
                                  <span>
                                    {paging.current_page - 1}
                                    {index + 1}
                                  </span>
                                )}

                                {index === 9 && (
                                  <span>{paging.current_page}0</span>
                                )}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                className="font-normal table-link text-[#011BB6]"
                                placeholder="Typography"
                                onPointerEnterCapture="none"
                                onPointerLeaveCapture="none"
                                onResize={() => {}}
                                onResizeCapture={() => {}}
                              >
                                <Link
                                  to={`/attendees/sports/${item.participant_id}/detail`}
                                  className="w-fit font-medium text-brand-500 hover:underline"
                                >
                                  {get(item, "full_name", "")}
                                </Link>
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                onPointerEnterCapture="none"
                                onPointerLeaveCapture="none"
                                onResize={() => {}}
                                onResizeCapture={() => {}}
                                variant="small"
                                className="font-normal"
                                placeholder="Typography"
                              >
                                {item.email}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                onPointerEnterCapture="none"
                                onPointerLeaveCapture="none"
                                onResize={() => {}}
                                onResizeCapture={() => {}}
                                variant="small"
                                className="font-normal"
                                placeholder="Typography"
                              >
                                {get(item, `event_name_${language}`, "")}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                onPointerEnterCapture="none"
                                onPointerLeaveCapture="none"
                                onResize={() => {}}
                                onResizeCapture={() => {}}
                                variant="small"
                                className="font-normal"
                                placeholder="Typography"
                              >
                                {item.category_name_vi}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                onPointerEnterCapture="none"
                                onPointerLeaveCapture="none"
                                onResize={() => {}}
                                onResizeCapture={() => {}}
                                variant="small"
                                className="font-normal"
                                placeholder="Typography"
                              >
                                {item.phone}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                onPointerEnterCapture="none"
                                onPointerLeaveCapture="none"
                                onResize={() => {}}
                                onResizeCapture={() => {}}
                                variant="small"
                                className="font-normal"
                                placeholder="Typography"
                              >
                                {item.id_card}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                onPointerEnterCapture="none"
                                onPointerLeaveCapture="none"
                                onResize={() => {}}
                                onResizeCapture={() => {}}
                                variant="small"
                                className="font-normal table-link text-[#011BB6]"
                                placeholder="Typography"
                              >
                                <Link
                                  to={`/orders/${item.order_code}`}
                                  className="w-fit font-medium text-brand-500 hover:underline"
                                >
                                  {get(item, "order_code", "")}
                                </Link>
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Tag text={item.source} type="blue" customClassName="capitalize" />
                            </td>
                            <td className={classes}>
                              {item.status === 1 &&
                                isHaveActionPermission(
                                  "sports",
                                  "attendees",
                                  "edit",
                                  permissions
                                ) && (
                                   <Button
                                    className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300"
                                    onClick={() => {
                                      navigate(`/attendees/sports/${item.participant_id}/edit`);
                                    }}
                                  >
                                    <PencilIcon className="w-4 h-4 text-black" />
                                  </Button>
                                )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              {paging && paging.total_page > 1 && (
                <Pagination
                  showTotal
                  paging={paging}
                  handlePageChange={handleAttendeesPagination}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WPSAttendeesSportsList;
